module.exports = __webpack_public_path__ + "static/masthead-a220ff427740bad634209ce4079774d3.jpg";